export default class Splitters {
  constructor(api) {
    this.api = api;
  }

  getByUUID(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/splitters/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/splitters", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/splitters/" + data.sp_uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/splitters/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getSplittersInObject(objectEndpoint, objectUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/" + objectEndpoint + "/" + objectUUID + "/splitters")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getObjectCables(objectEndpoint, objectUUID, cableType, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/" +
          objectEndpoint +
          "/" +
          objectUUID +
          "/cables-" +
          cableType +
          "?append=geometry"
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllCables(objectEndpoint, objectUUID, onSuccess, onError) {
    return this.api.http_fibercloud
      .get(
        "v1/" +
          objectEndpoint +
          "/" +
          objectUUID +
          "?include=cablein.fibers,cableout.fibers,splitters", {
            headers: {
              workspaceuuid: sessionStorage.getItem("workspace_uuid"),
              companyuuid: localStorage.getItem("company_uuid")
            }
          }
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  
  createConnection(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/splitters/portConnection", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editConnection(uuid, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/splitters/portConnection/" + uuid, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteConnection(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/splitters/portConnection/" + uuid)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/splitters.js